<template>
   <v-footer
    color="grey lighten-4"
    padless
  >
    <v-row
      justify="center"
      no-gutters
    >
    <v-spacer></v-spacer>
    <v-col md="4" cols="12" sm="12">
      <div class="Footer-wrapper text-center mt-5">
        <h3>{{ $t("infos").toUpperCase() }}</h3>
        <router-link class="d-block py-2" :to="termsPath()">{{ $t("terms_and_conditions")}}</router-link>
        <router-link class="d-block py-2" :to="privacyPath()">{{ $t("privacy_policy") }}</router-link>
        <router-link class="d-block py-2" :to="subscribeURL()">{{ $t("subscribe") }}</router-link>
         <v-dialog
        transition="dialog-bottom-transition"
        max-width="600"
      >
        <template v-slot:activator="{ on, attrs }">
        <a
          class="d-block py-2"
          v-bind="attrs"
          v-on="on"
        >
        {{ $t("legal_notes") }}
        </a>
        </template>
         <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >{{ $t("legal_notes") }}
            </v-toolbar>
            <v-card-text>
              <div class=" pa-12">
                <p>
                  Gotta Apps SAS
                  Chez InExtenso
                  24, chemin des Verrières,
                  69260 Charbonnières les Bains
                  France
                </p>
                <p>
                  Mail: info@gottayoga.app
                  Phone: +33 (0)6 37 64 33 58
                  Lyon Trade and Companies Register number: 801 905 266
                  VAT number: FR 89 801905266
                  Website made by: Gotta Apps SAS
                  Publication Manager: Maija Airas-Ceri, info@gottayoga.app
                  Hosts: ionos.de | keycdn.com | Firebase
                  Amazon Web Services
                </p>
              </div>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                text
                @click="dialog.value = false"
              >{{ $t("close") }}</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
      </div>
    </v-col>
    <v-col md="4" cols="12" sm="12">
      <div class="Footer-wrapper text-center  mt-5">
        <h3>{{ $t("codes_and_gift_cards").toUpperCase() }}</h3>
        <router-link class="d-block py-2" :to="useCodePath()">{{ $t("activate_my_code")}}</router-link>
        <router-link class="d-block py-2" :to="buyGiftCardPath()">{{ $t("buy_gift_card")}}</router-link>
        <router-link class="d-block py-2" :to="useGiftCardPath()">{{ $t("activate_gift_card")}}</router-link>
      </div>
    </v-col>
    <v-col md="4" cols="12" sm="12">
      <div class="Footer-wrapper text-center  mt-5">
        <h3>{{ $t("download").toUpperCase() }}</h3>
        <a class="d-block py-2" :href="iosURL()">{{ $t("for_ios") }}</a>
        <a class="d-block py-2" :href="androidURL()">{{ $t("for_android") }}</a>
      </div>
    </v-col>


       <v-col class="lighten-2 py-4 text-center" cols="12">
        &copy; <strong>{{ $t("app_name") }}</strong> {{ new Date().getFullYear() }} — All rights reserved
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
import { subscribeURL, iosURL, androidURL, privacyPath, termsPath, buyGiftCardPath, useGiftCardPath, useCodePath } from "@/common/language"

export default {
  name: 'CoreFooter',

  components: {

  },
  data: () => ({

  }),
  mounted () {
    this.$cookiebot.consentBanner()
  },
  methods: {
    iosURL() {
      return iosURL()
    },
    androidURL() {
      return androidURL()
    },
    subscribeURL() {
      return subscribeURL()
    },
    termsPath() {
      return termsPath()
    },
    privacyPath() {
      return privacyPath()
    },
    buyGiftCardPath() {
      return buyGiftCardPath()
    },
    useGiftCardPath() {
      return useGiftCardPath()
    },
    useCodePath() {
      return useCodePath()
    },
  }
};
</script>

<style scoped lang="scss">
  .Footer-wrapper {
    width: 30%;
    margin: 0 auto;
    text-align: left !important;
  }
  a {
    text-decoration: none;
    color: grey;
    &:hover{
      color: #03887D
    }
  }

</style>
